import { Button, Text, VStack } from '@chakra-ui/react';
import { ADVISOR_SIDE_PANEL_WIDTH } from '@kintsugi/advisor-ui';
import { Component, type ErrorInfo, type ReactNode } from 'react';

export class AdminAdvisorErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[AdminAdvisor] Render error:', error, info.componentStack);
  }

  private handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <VStack
          p={4}
          gap={3}
          bg="red.50"
          borderLeftWidth="1px"
          borderColor="red.100"
          w={ADVISOR_SIDE_PANEL_WIDTH}
          flexShrink={0}
          justify="center"
          align="center"
        >
          <Text fontSize="sm" color="red.700" textAlign="center">
            Kin encountered an error.
          </Text>
          <Button size="rg" variant="outline" colorPalette="red" onClick={this.handleRetry}>
            Try again
          </Button>
        </VStack>
      );
    }
    return this.props.children;
  }
}
